//
// Copyright (c) 2025 Emplifi, Inc.
//

import { Command, type ModelWriter } from "ckeditor5";
import {
  COLLAPSIBLE_SECTION,
  COLLAPSIBLE_SECTION_BODY,
  COLLAPSIBLE_SECTION_HEADER,
} from "./collapsibleSection.const";

export default class InsertCollapsibleSectionCommand extends Command {
  execute() {
    this.editor.model.change((writer) => {
      this.editor.model.insertObject(this._createCollapsibleSection(writer));
    });
  }

  refresh() {
    const firstPosition = this.editor.model.document.selection.getFirstPosition();
    const allowedIn = firstPosition
      ? this.editor.model.schema.findAllowedParent(firstPosition, COLLAPSIBLE_SECTION)
      : null;
    this.isEnabled = !!allowedIn;
  }

  private _createCollapsibleSection(writer: ModelWriter) {
    const collapsibleSection = writer.createElement(COLLAPSIBLE_SECTION, {
      open: true,
    });
    const collapsibleSectionBody = writer.createElement(COLLAPSIBLE_SECTION_BODY);
    const collapsibleSectionHeader = writer.createElement(COLLAPSIBLE_SECTION_HEADER);
    // To work around a CKEditor 5 bug, must append a paragraph to the Collapsible Section Body.
    // If it is not included, the body will not be able to be edited by the user.
    const collapsibleSectionBodyParagraph = writer.createElement("paragraph");
    writer.append(collapsibleSectionHeader, collapsibleSection);
    writer.append(collapsibleSectionBody, collapsibleSection);
    writer.append(collapsibleSectionBodyParagraph, collapsibleSectionBody);
    writer.appendText(
      this.editor.config.get("collapsibleSection.headerPlaceholder") as string,
      collapsibleSectionHeader,
    );
    writer.appendText(
      this.editor.config.get("collapsibleSection.bodyPlaceholder") as string,
      collapsibleSectionBodyParagraph,
    );
    return collapsibleSection;
  }
}
